module.exports = __webpack_public_path__ + "static/media/1.ff5c4aa7.svg";